<template>
  <div></div>
</template>

<script>
import store from '../store/store'
import {ebus} from '../vendor/ebus';
import * as xhr from '../api/xhr.js'
import * as qconst from '../vendor/qconstants'
import {getBtaste} from "@/vendor/bootstrap";
import {cloneMe} from "@/vendor/util";

export default {
  name: "FavoritesLifecycle",
  created() {
    ebus.$on('loadUserPreferences', () => {
      this.loadUserPreferences();
    });
    ebus.$on('saveUserPreferences', () => {
      this.saveUserPreferences();
    });
  },
  destroyed() {
  },
  beforeMount() {
  },
  methods: {
    filterItemsNotExisting(items, forDrinks) {
      if (!store.getters.cartProtected) {
        this.doFilterItemsNotExisting(items, forDrinks);
      } else {
        setTimeout(() => {
          //retry
          this.filterItemsNotExisting(items, forDrinks)
        }, 2000);
      }
    },
    getItemById(menu, itemId) {
      for (let category of menu) {
        let item = category.items.find(u => u.id === itemId);
        if (item) {
          return item
        }
      }
      return null;
    },
    doFilterItemsNotExisting(items, forDrinks) {
      let relevant = [];
      let menu = forDrinks ? store.getters.allDrinkMenu : store.getters.allFoodMenu;
      for (let item of items) {
        let found = this.getItemById(menu, item.id);
        if (found) {
          relevant.push(item);
        } else {
          console.log('fav item filtered: ' + item.nameToDisplay);
        }
      }

      //update vuex
      if (forDrinks) {
        store.commit('favDrinks', relevant);
        console.log('favDrinks filtered');
      } else {
        store.commit('favFoods', relevant);
        console.log('favFoods filtered');
      }
    },
    async saveUserPreferences() {
      let updates = cloneMe(store.getters.userPreferences);
      let updateDoc = {
        action: qconst.action$DocUpserter,
        collectionName: 'userPreferences',
        updates: updates,
        subjectKey: {
          key: 'deviceId',
          value: getBtaste()
        },
        autoRetry: false,
      };
      let email = this.getEmail();
      if (email) {
        updates.email = email;
      } else {
        // updates.email = '';
      }
      await xhr.xhrSend(true, updateDoc, (reply) => {
        if (reply && reply.ok) {
          console.log('userPreferences saved successfully');
        }
      });
    },

    getEmail() {
      let bbnUser = this.$ls.get('bbnUser');
      if (bbnUser && bbnUser.email) {
        return bbnUser.email;
      }
      return null;
    },

    async loadUserPreferences() {
      console.log('loadUserPreferences');

      let email = this.getEmail();

      let orClauses = [];
      orClauses.push({deviceId: getBtaste()});
      let msg = {
        action: qconst.action$LoadDocs,
        collectionName: 'userPreferences',
        query: {'$or': orClauses}
      };
      if (email) {
        orClauses.push({email: email})
      }
      await xhr.xhrSend(true, msg, (data) => {
        if (data && data.ok && data.docs && Array.isArray(data.docs)) {
          let docs = data.docs;
          console.log('number of userPreferences docs: ' + docs.length);
          if (docs.length > 0) {
            store.commit('userPreferences', docs[0]);
          }
          this.filterItemsNotExisting(store.getters.favDrinks, true);
          this.filterItemsNotExisting(store.getters.favFoods, false);
        } else {
          console.log('error loading userPreferences');
        }
      });
    },

  }
}
</script>

<style scoped>

</style>
